import { zodValidator } from '@tanstack/zod-adapter';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MembersPage, type MembersSearchState } from '../features/team/team-pages';

const SearchSchema = z.object({
  page: z.number().int().positive().catch(1),
  pageSize: z.union([z.literal(10), z.literal(25), z.literal(50), z.literal(100)]).catch(25),
  role: z.enum(['OWNER', 'ADMIN', 'EDITOR', 'VIEWER']).optional().catch(undefined),
  scopeMode: z.enum(['ALL', 'RESTRICTED']).optional().catch(undefined),
  search: z.string().trim().max(200).optional().catch(undefined),
  status: z.enum(['ACTIVE', 'SUSPENDED']).optional().catch(undefined),
});

export const Route = createFileRoute('/manage/$companySlug/settings/members')({
  component: MembersRoute,
  validateSearch: zodValidator(SearchSchema),
});

function MembersRoute() {
  const { companySlug } = Route.useParams();
  const searchState: MembersSearchState = Route.useSearch();
  const navigate = Route.useNavigate();
  const update = (patch: Partial<MembersSearchState>) =>
    void navigate({ search: (previous) => ({ ...previous, ...patch, page: patch.page ?? 1 }) });
  return (
    <MembersPage
      companySlug={companySlug}
      onPageChange={(page) => update({ page })}
      onRoleChange={(role) => update({ role })}
      onScopeChange={(scopeMode) => update({ scopeMode })}
      onSearchChange={(search) => update({ search })}
      onStatusChange={(status) => update({ status })}
      searchState={searchState}
    />
  );
}
